import React from "react";

import { Link } from "react-router-dom";

import "../css/Navbar.css";

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link className="navbar-brand" href="#" to="/">
          About Me
        </Link>
        <div className="navbar-menu">
          <Link className="navbar-item" href="#" to="/factory-automation">
            Automation
          </Link>
          <Link className="navbar-item" href="#" to="/fullstack">
            Fullstack
          </Link>
          <Link className="navbar-item" href="#" to="/cloud-computing">
            Cloud Computing
          </Link>
          <Link className="navbar-item" href="#" to="/cv">
            My CV
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;